import axios from 'axios';

const BASE_BRANCH_USERS_URL = '/ztna_branches';

export function getBranchUsers() {
  return axios.get(`${BASE_BRANCH_USERS_URL}/users`);
}

export function getBranchGroups() {
  return axios.get(`${BASE_BRANCH_USERS_URL}/groups`);
}
